/**
 * Controller: RemoveAddressModal
 */
angular.module('acme.view.application.partners.create.removeAddressModal.controllers', [])
.controller('RemoveAddressModalController', [ '$scope', '$uibModalInstance', 'address', function($scope, $uibModalInstance, address) {

    $scope.removeAddressModal = {

      model: {},
      address: '',
      allowRemove: true,

      init: function() {
        this.model = address;
        this.address = this.process(address);
        if (address.isPrimary) {
          this.allowRemove = false;
        }
      },

      process: function(address) {

        var r = '';

        if (address) {
          if (address.streetAddress1) {
            r += address.streetAddress1;
          }

          if (address.streetAddress2) {
            r += ' ' + address.streetAddress2;
          }

          if (address.city) {
            r += ', ' + address.city;
          }

          if (address.state) {
            r += ', ' + address.state;
          }

          if (address.country) {
            r += ' ' + address.country;
          }

          if (address.zipCode) {
            r += ' ' + address.zipCode;
          }
        }

        return r;

      },

      done: function() {
        if (this.allowRemove) {
          $uibModalInstance.close(this.model);
        }else{
          this.cancel();
        }
      },

      cancel: function() {
        $uibModalInstance.dismiss('cancel');
      }
    };

    $scope.removeAddressModal.init();

}]);